// globals: jQuery, __setCreditCardInfo

import cardConnectIframeAbstract from './cardConnectFrameAbstract';

var cardConnectIframeSaveUserCard;

(function($) {
    var __setCreditCardPaymentInfo = function(data) {
        var cardType;
        var firstDigit = data.cc_number.charAt(0);
        switch (firstDigit) {
            case '3':
                cardType = 'amex';
                break;
            case '4':
                cardType = 'visa';
                break;
            case '5':
                cardType = 'mastercard';
                break;
            case '6':
                cardType = 'discover';
                break;
            default:
                cardType = 'unknown';
        }
        var preparedData = {
            paymentProcessorUniqueId: data.cc_merchant_unique_id,
            expirationMonth: data.expiration_month,
            expirationYear: data.expiration_year,
            cardNumber: data.cc_number,
            cardType: cardType,
        };

        __setCreditCardInfo(preparedData);
    };

    cardConnectIframeSaveUserCard = new cardConnectIframeAbstract({
        frameContainer: 'saveUserCard_i4goFrame',
        iframeLocation: 'profile',
        frameAutoResize: false,
        template: undefined,
        iframeStyle: 'style="width:100%;height:100%;"',
        label: {
            classes:"control-label col-xs-4 text-right",
        }
    });

    var __postToParent = function (data) {
        var parentWindow = window.parent;
        if (parentWindow === window) {
            parentWindow = window.opener;
        }

        var parameters = {};
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            parameters[key] = decodeURIComponent(value);
        });

        if (parameters.parentUrl) {
            var parentLocation = parameters.parentUrl;
        }

        let dataPrepared;
        const responseType = 'SUCCESS';
        if (parentLocation && parentWindow) {
            dataPrepared = {
                i4go_uniqueid: data.cc_merchant_unique_id,
                cc_number: data.cc_number,
                i4go_expirationyear: data.expiration_year,
                i4go_expirationmonth: data.expiration_month,
                i4go_response: responseType
            };
            dataPrepared = {...data, ...dataPrepared};
            parentWindow.postMessage(dataPrepared, parentLocation);
        }
    };

    cardConnectIframeSaveUserCard.onSuccess = function(form, data) {
        __setCreditCardPaymentInfo(data);
        __postToParent(data);

        var cardMustBeSaved = $(form).find('[name=card_on_file]').val();
        if (!cardMustBeSaved) {
            window.close();
            return;
        }

        var url = '/i4go/save-user-card';

        data.ca_token = $(form).find('[name=ca_token]').val();

        $.caPost(
            url,
            data,
            function(response) {
                if (response.status === 1) {
                    window.close();
                } else {
                    $.caAlert(response.error);
                }
            },
            'json',
            true
        );
    };

    cardConnectIframeSaveUserCard.onFailure = function() {
        $.caAlert('Something went wrong... Please try again later.');
    };

})(jQuery);

export default cardConnectIframeSaveUserCard;
